import * as $ from "jquery";
import Handlebars from "Handlebars";

export default class CartComponent {
    constructor() {
        this.componentSelector = "#product-search";
        this.cartTemplateSelector = "#checkout-cart-template";
        this.cartErrorsTemplateSelector = "#checkout-carterrors-template";
        this.shippingTemplateSelector = "#checkout-shipping-template";
        this.cartResultSelector = "#checkout-cart";
        this.cartErrorsSelector = "#checkout-cart-errors";
        this.shippingResultSelector = "#checkout-shipping";
        this.searchResultTemplate;
        this.cartErrorsTemplate;
        this.shippingTemplate;
        this.instance = this;
        this.debounceTimer = null;
        this.lastQuery = "";
    }

    init() {
        let instance = this;

        if ($(instance.componentSelector).length > 0) {
            const cartTemplate = $(this.cartTemplateSelector).html();
            const cartErrorsTemplate = $(this.cartErrorsTemplateSelector).html();
            if (cartTemplate !== undefined) {
                this.searchResultTemplate = Handlebars.compile(cartTemplate);
            }
            if (cartErrorsTemplate !== undefined) {
                this.cartErrorsTemplate = Handlebars.compile(cartErrorsTemplate);
            }
            instance.cart(instance);
        }
    }

    add(sku, quantity, marketId, callback, instance, isRebateRow) {
        let promoCode = $('#checkout-promocode').val();

        axios({
            method: 'post',
            url: "/cart/add",
            data: { sku: sku, quantity: quantity, marketId: marketId, promotionCode: promoCode }
        }).then(function (response) {
            if (!isRebateRow) {
                callback(response.data, instance);
            }

            $('.search-result tr[data-id="' + sku + '"]').addClass("flashrow");
            setTimeout(function () {
                $('.search-result tr[data-id="' + sku + '"]').removeClass("flashrow");
            }, 1600);

        }).catch(function (response) {
        });
    }

    cart(callback, instance) {
        let promoCode = $('#checkout-promocode').val();

        axios({
            method: 'get',
            url: "/cart/get",
            data: { promotionCode: promoCode }
        }).then(function (response) {
            callback(response.data, instance);
        }).catch(function (response) {
        });
    }

    emptyCart(callback, instance) {
        bootbox.confirm({
            message: 'Vill du tömma varukorgen? Detta går inte att ångra.',
            buttons: {
                confirm: {
                    label: 'Töm varukorg'
                },
                cancel: {
                    label: 'Avbryt'
                }
            },
            callback: function (result) {
                if (result) {
                    axios({
                        method: 'post',
                        url: "/cart/emptycart"
                    }).then(function () {
                        instance.cart.cart(callback, instance);
                    }).catch(function (error) {
                        console.error(error);
                        console.error(error.response);
                    });
                }
            }
        });
    }
}